import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ICustomizationAnswer } from '../../../store/slices/customization/customization';

interface Props {
  foregroundColor: string;
  answer: ICustomizationAnswer;
}

class InputStyle extends Component<Props> {
  render() {
    const { foregroundColor, answer } = this.props;
    const { color } = answer;
    return (
      <style type="text/css" scoped>
        {`
          .short-input-field{
            font-family: ${answer.font};
            border: 1px solid ${foregroundColor};
            color: ${color}
          }
          .long-input-field{
            font-family: ${answer.font} !important;
            border: 1px solid ${foregroundColor} !important;
            color: ${color}
          }
          .input-row-label{
            font-family: ${answer.font};
          }
          .short-input-field:hover,
          .short-input-field:active,
          .short-input-field:focus,
          .long-input-field:hover,
          .long-input-field:active,
          .long-input-field:focus{
            box-shadow: 0 0 1px 6px ${foregroundColor}15;
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    customization: { foregroundColor, answer },
  } = state;
  return {
    foregroundColor,
    answer,
  };
};

export default connect(mapStateToProps)(InputStyle);
